import { createSlice } from '@reduxjs/toolkit';

// Usage: import this dialogData in component and put into the setDialogMessage()
// Explain: nested object instead of one line due to flexibilty in future
// e.g dispatch(setDialogMessage(dialogData.firstName.content))
export const dialogData = {
    firstName: {
        content: '@NewPatient.warning.firstName',
    },
    lastName: {
        content: '@NewPatient.warning.lastName',
    },
    city: {
        content: '@NewPatient.warning.city',
    },
    zipCode: {
        content: '@NewPatient.warning.postCode',
    },
    phone: {
        content: '@NewPatient.warning.phoneNo',
    },
    accessoriesQuantity: {
        content: '@NewPatient.warning.accessories_quantity',
    },
    tooth: {
        content: '@NewPatient.warning.tooth',
    },
    value: {
        content: '@NewPatient.warning.value',
    },
    locationOfTheSpace: {
        content: '@NewPatient.warning.locationOfTheSpace',
    },
    checkbox: {
        content: '@NewPatient.warning.checkbox',
    },
    specifyArea: {
        content: '@NewPatient.warning.specifyArea',
    },
    option: {
        content: '@NewPatient.warning.option',
    },
    prescriptionNotes: {
        content: '@NewPatient.prescriptionNotes.otherElasticsHintText',
    },
    allMandatory: {
        content: '@NewPatient.warning.allMandatory',
    },
    restorativeOptions: {
        subValue: '@NewPatient.warning.verticalDimensionQuestion',
        // ToothArea: '@NewPatient.warning.verticalDimensionQuestion_ToothArea',
        // JawPosition: '@NewPatient.warning.verticalDimensionQuestion_JawPosition',
        // Increase: '@NewPatient.warning.verticalDimensionQuestion_Increase',
        posterior: '@NewPatient.warning.verticalDimensionPosterior',
    },
    archToTreat: {
        content: '@NewPatient.warning.archToTreat',
    },
    anteriorPosteriorRelationship: {
        content: '@NewPatient.warning.anteriorPosteriorRelationship',
    },
    spacingAndCrowding: {
        content: '@NewPatient.warning.spacingAndCrowding',
    },
    auxiliariesElastics: {
        content: '@NewPatient.warning.auxiliariesElastics',
    },
    attachmentsRequired: {
        content: '@NewPatient.warning.attachmentsRequired',
    },
};

export const errorMessageSlice = createSlice({
    name: 'errorMessage',
    initialState: {
        isOpen: false,
        dialogTitle: '', // Optional title override; empty string means use the default ":const.warning" in ErrorDialog
        dialogMessage: '',
        dialogData: dialogData, // Reminder: no suggestion in useSelector, therefore importing diaglogData instead of usign useSelector
        dialogFunction: () => {}, // Usage: add extra function in dialog close button
    },

    reducers: {
        setIsOpen: (state, action) => {
            state.isOpen = action.payload;
        },
        setDialogMessage: (state, action) => {
            // Usage: set the dialog message from dialog data
            state.dialogMessage = action.payload;
            state.dialogTitle = '';
            state.isOpen = true;
        },
        setDialog: (state, action) => {
            // Usage: set both the dialog title and message in one dispatch
            // Payload shape: { title?: string, content: string }
            const { title = '', content = '' } = action.payload || {};
            state.dialogTitle = title;
            state.dialogMessage = content;
            state.isOpen = true;
        },
        closeDialog: (state, action) => {
            state.isOpen = false;
            state.dialogTitle = '';
            state.dialogFunction = () => {};
        },
        setDialogFunction: (state, action) => {
            state.dialogFunction = action.payload;
        },
    },
});

export const { setIsOpen, setDialogMessage, setDialog, closeDialog, setDialogFunction } = errorMessageSlice.actions;
export default errorMessageSlice.reducer;
